module.exports = __webpack_public_path__ + "static/media/daisy-ridley-lose.88f5fa47.jpg";